export default __webpack_public_path__ + "static/media/logo_moongy.9d4a128d.svg";